module.exports = "<div class=\"main__menu\" [class.open]=\"opened\">\n    <div class=\"btn\" (click)=\"open(!opened)\">\n        <div class=\"icon\">\n            <span></span>\n            <span></span>\n            <span></span>\n            <span></span>\n        </div>\n    </div>\n    <div  class=\"content\">\n        <div id=\"main_menu_container\">            \n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/module/main-menu/main-menu.component.html
// module id = 750
// module chunks = 0